import { Formik } from "formik"
import { Modal, ModalBody, ModalFooter, ModalHeader, ModalTitle } from "react-bootstrap"
import { Facsimile } from "../../types"
import FacsimileForm from "./FacsimileForm"
import { Button } from "@inmagik/magik-ui"
import { initialValuesFacsimile, validationSchemaFacsimile } from "./FacsimileCommon"

export default function FacsimileModal({
  title,
  facsimile,
  save,
  show,
  onClose,
  showEdizione = false,
}: {
  title: string
  facsimile?: Facsimile
  save: (values: Facsimile) => Promise<void>
  show: boolean
  onClose: () => void
  showEdizione?: boolean
}) {
  return (
    <Formik
      enableReinitialize
      initialValues={initialValuesFacsimile(facsimile) as Facsimile}
      validationSchema={validationSchemaFacsimile(showEdizione)}
      onSubmit={save}
    >
      {({ handleSubmit }) => (
        <Modal centered show={show} onHide={onClose} size="lg" backdrop="static">
          <form onSubmit={handleSubmit}>
            <ModalHeader>
              <ModalTitle>{title}</ModalTitle>
            </ModalHeader>
            <ModalBody
              style={{
                maxHeight: "calc(100vh - 200px)",
                overflowY: "auto",
              }}
            >
              <FacsimileForm col={12} showEdizione={showEdizione} />
            </ModalBody>
            <ModalFooter className="d-flex justify-content-between">
              <Button onClick={onClose} title="Annulla" size="md" outline leadingIcon="close" />
              <Button type="submit" title="Salva" size="md" leadingIcon="check" className="text-white" />
            </ModalFooter>
          </form>
        </Modal>
      )}
    </Formik>
  )
}
